module.exports = __webpack_public_path__ + "media/images/icon__calendar-b34ece654e72a7a5a3968d28201b67a2.png";